import type { VoidFunctionComponent } from 'react';

import { isFreeTier } from '../../../../../shared/subscriptions/utils';
import { window } from '../../../../globals';
import Button from '../../../generic/Button/Button';
import PaidFeatureGate from '../../../generic/Gates/PaidFeatureGate';
import { icons } from '../../../generic/Icon/icons';
import { Icon } from '../../../generic/Icon/index';
import { ExportIssuesModalDetailsContainer } from '../../modals';
import { useIssueDetailsModals } from '../IssueDetailsModalsContext';
import type { Issue } from '../../../../../shared/issuesV2';

import { SELECTED_ISSUE_COUNT } from './shared';
import type { ActionButtonAndModalProps } from './shared';

type Props = ActionButtonAndModalProps & {
  issue: Issue;
  //  The count of number of unique Jira tickets which currenty exist on this issue.
  //  This will only be set for the global scope issue details.
  jiraTicketCount?: number;
};

/**
 * IssueDetailsActionButtonExport includes the button and the modal
 * for the export action on the issue details page and drawer. The modal state is managed
 * by useIssueDetailsModals, which passes the modal state down as context. Go see the
 * IssueDetailsModalsContext for more info.
 */
const IssueDetailsActionButtonExport: VoidFunctionComponent<Props> = ({
  id,
  issue,
  jiraTicketCount = 0,
}) => {
  const { exportModal, isAnyModalOpen } = useIssueDetailsModals();

  const isOrgOnFreeTier = isFreeTier({
    plan: window.user?.organization?.stripe_plan,
    stripePriceLimit: window.user?.organization?.stripePriceLimit,
  });

  return (
    <>
      <PaidFeatureGate isRestricted={isOrgOnFreeTier} hidePill>
        <Button
          type="secondary"
          size="medium"
          onClick={exportModal.onOpen}
          isDisabled={isAnyModalOpen}
        >
          Create Ticket
          {' '}{isOrgOnFreeTier && <Icon icon={icons.lockOutline} />}
        </Button>
      </PaidFeatureGate>
      <ExportIssuesModalDetailsContainer
        id={id}
        show={exportModal.isOpen}
        issue={issue}
        onHide={exportModal.onClose}
        selectedIssuesCount={SELECTED_ISSUE_COUNT}
        jiraTicketCount={jiraTicketCount}
      />
    </>
  );
};

export default IssueDetailsActionButtonExport;
